void (function () {
  const processSectionExists = document.querySelector(
    '.VendorWidget__description a'
  )
  if (processSectionExists) {
    processSectionExists.classList.add('CTA-text-primary')
  }
})()
